export default __webpack_public_path__ + "static/Search&Rescue-39994322de5886ca6eef034fb09159ab.mp4";